import { useMemo } from "react";
import Token from "../config/token.service";
import { useLoginStatusStore } from "../config/user.stores";

export const useUser = () => {
    const userLoggedIn = useLoginStatusStore((state) => state.userLoggedIn);

    return useMemo(() => {
        if (userLoggedIn) {
            return Token.getUser();
        }
        return null;
    }, [userLoggedIn]);
}
